import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IAccountState } from './account.state';

export class AccountSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly accountState = (state: IRootState): IAccountState => {
    return state.account as IAccountState;
  };

  static readonly model = createSelector(AccountSelectors.accountState, (account: IAccountState) => {
    return account.model;
  });

  static readonly data = createSelector(AccountSelectors.accountState, (account: IAccountState) => {
    return account.data;
  });
}
